/**
 * useViewNavigation Hook
 *
 * Manages view/tab navigation and device view mode state.
 * Extracted from AppContent.js as part of Phase 1 refactoring.
 *
 * Features:
 * - Current view state ('devices' or 'patrons')
 * - Device view mode ('detailed' or 'grid')
 * - Navigation callbacks
 * - Automatic persistence via Zustand
 *
 * @returns {Object} Navigation state and actions
 */

import { useState } from "react";
import { useUIStore } from "../stores";
import logger from "../utils/logger";

export const useViewNavigation = () => {
  // Get device view mode from UIStore (persisted)
  const deviceViewMode = useUIStore((state) => state.deviceViewMode);
  const setDeviceViewMode = useUIStore((state) => state.setDeviceViewMode);

  // Current view is transient (not persisted - resets to devices on reload)
  const [currentView, setCurrentView] = useState("devices");

  // Navigation callbacks
  const navigateToDevices = () => {
    setCurrentView("devices");
    logger.log("[useViewNavigation] Navigated to devices view");
  };

  const navigateToPatrons = () => {
    setCurrentView("patrons");
    logger.log("[useViewNavigation] Navigated to patrons view");
  };

  const handleViewModeChange = (mode) => {
    setDeviceViewMode(mode);
    logger.log(`[useViewNavigation] Device view mode changed to: ${mode}`);
  };

  return {
    currentView,
    setCurrentView,
    navigateToDevices,
    navigateToPatrons,
    deviceViewMode,
    setDeviceViewMode,
    handleViewModeChange,
  };
};
